import React, { useState } from "react";
import CertificationStagingNetsFlow from "../../assets/diagrams/certification_staging_nets_flow.png";
import Header from "../components/developer_header.jsx";
import Footer from "../components/developer_footer.jsx";

const ProjectCertificationOptionLayout = () => {
  // State for notification
  const [notification, setNotification] = useState({
    visible: false,
    message: ""
  });

  // Function to show notification
  const showNotification = (message) => {
    setNotification({ visible: true, message });
    // Hide notification after 3 seconds
    setTimeout(() => {
      setNotification({ visible: false, message: "" });
    }, 3000);
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Header/>
      
      {/* Notification component - more mobile friendly positioning and sizing */}
      {notification.visible && (
        <div className="fixed top-4 right-4 bg-blue-600 text-white px-4 py-2 sm:p-4 rounded-md shadow-lg z-50 text-sm sm:text-base max-w-[85vw] sm:max-w-md">
          {notification.message}
        </div>
      )}

      {/* Breadcrumb - responsive text and spacing */}
      <div className="bg-gray-100 py-2 sm:py-3">
        <div className="container mx-auto px-4 sm:px-6">
          <p className="text-xs sm:text-sm text-gray-600 text-left truncate">
            <a href="/get-started" className="text-blue-600 hover:underline">Get Started</a> &gt; 
            <a href="/certification-journey" className="text-blue-600 hover:underline"> Certification Journey</a> &gt; 
            <span className="hidden sm:inline"> NETS Certification Process (Staging)</span>
            <span className="inline sm:hidden"> Staging</span>
          </p>
        </div>
      </div>

      {/* Main Content - responsive padding and sizing */}
      <main className="container mx-auto px-4 sm:px-6 py-6 sm:py-12 flex-grow">
        <div className="w-full max-w-3xl mx-auto bg-white rounded-lg shadow-md p-4 sm:p-8">
          <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-800 mb-4 sm:mb-6 text-center">Project Certification Option</h2>
          
          <div className="space-y-4 sm:space-y-6">
            <p className="text-sm sm:text-base text-gray-700 text-justify max-w-2xl mx-auto">
              Welcome to OPENAPIPASS NETS Certification Process for Staging! This tutorial will guide you on how to get a certificate on NETS Staging.
            </p>
            
            <p className="text-sm sm:text-base text-gray-700 text-justify max-w-2xl mx-auto">
              In software development, "staging" refers to a pre-production environment that closely mirrors the live production environment, where developers test software updates, new features, and entire applications before deploying them to end-users.
            </p>
            
            <p className="text-sm sm:text-base text-gray-700 text-justify max-w-2xl mx-auto">
              Why SHA256 is required for both developer projects and NETS coursework? Simple, because the staging environment mirrors the API authentication and authorization process in the production environment.
            </p>
            
            <p className="text-sm sm:text-base text-gray-700 font-medium text-center px-2">
              The diagram below shows 2 options: Coursework or Create your own project.
              <span className="block mt-1">Click the button that suits your needs!</span>
            </p>

            {/* Diagram - responsive image */}
            <div className="flex justify-center my-4 sm:my-10">
              <img 
                src={CertificationStagingNetsFlow} 
                alt="NETS Certification Options" 
                className="rounded-md w-full max-w-lg shadow-sm" 
              />
            </div>

            {/* Buttons - stack on mobile, side by side on desktop */}
            <div className="flex flex-col sm:flex-row justify-center sm:space-x-6 space-y-4 sm:space-y-0 mt-4 sm:mt-10">
              <button 
                onClick={() => window.location.href = "/certification-journey/staging/coursework"} 
                className="bg-blue-600 hover:bg-blue-700 text-white py-2 sm:py-3 px-4 sm:px-8 rounded-md font-medium transition duration-300 w-full sm:w-60 text-center"
              >
                Coursework
              </button>
              
              <button 
                onClick={() => showNotification("Coming Soon! This feature will be available in the future.")}
                className="bg-gray-600 hover:bg-gray-700 text-white py-2 sm:py-3 px-4 sm:px-8 rounded-md font-medium transition duration-300 w-full sm:w-60 text-center focus:outline-none"
              >
                Create your own project
              </button>
            </div>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default ProjectCertificationOptionLayout;